module.exports = "<p>\r\n  login-forge works!\r\n</p>\r\n"